import { SyncModel, SyncDataModel, DataModel } from "../../core/shared/models/syncModel";

// Requests
export class SOTStyleSyncModel extends SyncModel {
  public hyp_cus_nr: number;
}

// Responses
export class SOTStyleDataModel extends DataModel {
  public get DM_Key(): number | string { return this.key; }
  public key: string;
  public value: string;
}

export class SOTStyleSyncDataModel extends SyncDataModel {
  public styles: SOTStyleDataModel[];
  public get models(): DataModel[] { return this.styles; }
  public DeserializeType(): void {
    this._DeserializeType(SOTStyleDataModel);
  }
}
